const { API_DOMAIN_PATH, APP_URL, IDEAL_TIME } = window.__RUNTIME_CONFIG__;
const { DASHBOARD_INDEX_DESCRIPTION, DASHBOARD_LISTINGS_DESCRIPTION, PAGES_HEADER_INFO, } = window._runtime_properties;
export { API_DOMAIN_PATH, APP_URL, IDEAL_TIME, DASHBOARD_INDEX_DESCRIPTION, DASHBOARD_LISTINGS_DESCRIPTION, PAGES_HEADER_INFO, };
